import React from "react";
import AddConfigDialog from "./AddConfigModal";
import EditConfigDialog from "./EditConfigModal";
import DeleteConfigDialog from "./DeleteConfigModal";

const ConfigurationDialogs = ({ configs, setConfigs, addConfig, editConfig, removeConfig }: any) => (
    <>
        <AddConfigDialog
            open={configs.openAdd}
            onClose={() => setConfigs((prev: typeof configs) => ({ ...prev, openAdd: false }))}
            onSave={(name, value) => addConfig(name, value)}
        />

        <EditConfigDialog
            open={configs.openEdit}
            onClose={() => setConfigs((prev: typeof configs) => ({ ...prev, openEdit: false }))}
            config={configs.currentConfig}
            onSave={(id, name, value) => editConfig(id, name, value)}
        />

        <DeleteConfigDialog
            open={configs.openDelete}
            onClose={() => setConfigs((prev: typeof configs) => ({ ...prev, openDelete: false }))}
            config={configs.currentConfig}
            onDelete={(id) => removeConfig(id)}
        />

    </>
);

export default ConfigurationDialogs;
